<template>
  <div>
    <FilterModal ref="filterModal" @filter="onFilter"/>
    <SearchModal @search="onSearch" ref="searchModal"/>
    <div class="d-flex align-items-center">
      <FilterBadges @filter="onFilter"/>
      <div class="mr-2">
        <CButton @click="openFilter" size="sm" color="secondary" class="mr-2">
          <CIcon name="cipSettings"/>
          <translate>Filter</translate>
        </CButton>
        <CButton @click="openSearch" size="sm" color="secondary" class="mr-2">
          <CIcon name="cipSearch2"/>
          <translate>Search</translate>
        </CButton>
        <CButton @click="openUpload" size="sm" color="primary" v-if="canUpload">
          <CIcon name="cipUpload2"/>
          <translate>Upload</translate>
        </CButton>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex"
import FilterModal from "@/domain/photoSearch/components/FilterModal.vue";
import SearchModal from "@/domain/photoSearch/components/SearchModal.vue";
import FilterBadges from "@/domain/photoSearch/components/FilterBadges.vue";

export default {
  name: "FiltersBar",
  components: {FilterBadges, SearchModal, FilterModal},
  emits: ['filter', 'search', 'upload'],
  props: {
    canUpload: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  computed: {
    ...mapGetters('photoSearch', [
      'searchResult'
    ]),
  },
  methods: {
    ...mapActions('photoSearch', [
      'setSearchQuery',
    ]),
    openFilter() {
      this.$refs.filterModal.open()
    },
    openSearch() {
      this.$refs.searchModal.open()
    },
    onFilter(value) {
      this.$emit('filter', value)
    },
    openUpload() {
      this.$emit('upload')
    },
    async onSearch(query) {
      await this.setSearchQuery(query)
      if (!this.searchResult)
        await this.notifyError('No results found')
    },
  }
}
</script>